import React, { useState, useEffect } from 'react';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';
import api, { getFileUrl } from '../../lib/api';

export default function CorporateEditor() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    api.get('/settings/corporate')
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      let imagePath = data.image_path || '';
      if (imageFile) {
        const fd = new FormData();
        fd.append('file', imageFile);
        const res = await api.post('/uploads', fd);
        imagePath = res.data.path;
      }
      await api.put('/settings/corporate', { ...data, image_path: imagePath });
      setData(prev => ({ ...prev, image_path: imagePath }));
      toast.success('Kurumsal içerik güncellendi');
    } catch (err) {
      toast.error('Hata oluştu');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading) return <div className="flex justify-center py-20"><div className="w-8 h-8 border-2 border-[hsl(var(--gold))] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div data-testid="admin-corporate-editor">
      <h1 className="font-heading text-2xl font-semibold mb-6">Kurumsal İçerik</h1>
      <form onSubmit={handleSubmit} className="space-y-6 p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Field label="Hakkımızda Başlık" value={data?.about_title || ''} onChange={v => setData(d => ({ ...d, about_title: v }))} />
          <Field label="Misyon Başlık" value={data?.mission_title || ''} onChange={v => setData(d => ({ ...d, mission_title: v }))} />
        </div>
        <TextArea label="Hakkımızda Metni" value={data?.about_text || ''} onChange={v => setData(d => ({ ...d, about_text: v }))} rows={6} />
        <TextArea label="Misyon Metni" value={data?.mission_text || ''} onChange={v => setData(d => ({ ...d, mission_text: v }))} rows={4} />
        <Field label="Vizyon Başlık" value={data?.vision_title || ''} onChange={v => setData(d => ({ ...d, vision_title: v }))} />
        <TextArea label="Vizyon Metni" value={data?.vision_text || ''} onChange={v => setData(d => ({ ...d, vision_text: v }))} rows={4} />

        <div>
          <label className="block text-sm font-medium mb-1.5">Kurumsal Gorsel</label>
          <div className="flex items-center gap-4">
            <label className="cursor-pointer inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-input bg-background text-sm hover:bg-secondary transition-colors">
              <Upload className="w-4 h-4" /> Görsel Seç
              <input type="file" accept="image/*" className="hidden" onChange={e => setImageFile(e.target.files[0])} />
            </label>
            <span className="text-sm text-muted-foreground">{imageFile?.name || ''}</span>
          </div>
          {data?.image_path && <img src={getFileUrl(data.image_path)} alt="" className="mt-2 h-32 rounded-lg object-cover" />}
        </div>

        <button type="submit" disabled={isSubmitting} className="px-6 py-2.5 rounded-lg bg-[hsl(var(--gold))] text-[hsl(var(--accent-foreground))] text-sm font-medium hover:bg-[hsl(var(--gold)/0.92)] disabled:opacity-50" data-testid="admin-save-button">
          {isSubmitting ? 'Kaydediliyor...' : 'Kaydet'}
        </button>
      </form>
    </div>
  );
}

const Field = ({ label, value, onChange }) => (
  <div>
    <label className="block text-sm font-medium mb-1.5">{label}</label>
    <input value={value} onChange={e => onChange(e.target.value)} className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))]" />
  </div>
);

const TextArea = ({ label, value, onChange, rows = 4 }) => (
  <div>
    <label className="block text-sm font-medium mb-1.5">{label}</label>
    <textarea value={value} onChange={e => onChange(e.target.value)} rows={rows} className="w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))] resize-none" />
  </div>
);
